/**
 * Optimistic-concurrency header helper.
 *
 * Mutating endpoints across the PRD, prompt, artefact, and telemetry-policy
 * registries guard against concurrent edits with an If-Match header carrying
 * the row's current metadata/policy version; the backend answers 412 on a
 * stale value. One builder keeps the header name and number-to-string
 * coercion identical at every call site.
 */

/** Request-config fragment for endpoints where If-Match is REQUIRED. */
export const ifMatchHeaders = (
  version: number
): { headers: { 'If-Match': string } } => ({
  headers: { 'If-Match': String(version) },
})

/**
 * Request-config fragment for endpoints where If-Match is OPTIONAL —
 * omitting the version yields last-write-wins semantics on the backend.
 */
export const optionalIfMatchHeaders = (
  version?: number
): { headers: { 'If-Match': string } } | undefined =>
  version != null ? ifMatchHeaders(version) : undefined
